(function() {
    'use strict';

    angular
        .module('netWordAgroApp')
        .controller('DiariodebordoDialogController', DiariodebordoDialogController);

    DiariodebordoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'Diariodebordo', 'Propriedade', 'Safra'];

    function DiariodebordoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, Diariodebordo, Propriedade, Safra) {
        var vm = this;

        vm.diariodebordo = entity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.propriedades = Propriedade.queryNomesPropriedades({
            size: 1000,
            sort: "nomepropriedade,asc"
        });

        vm.safras = Safra.querySafraIdNome({
            size: 1000,
            sort: "nomesafra,asc"
        });

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.diariodebordo.id !== null) {
                Diariodebordo.update(vm.diariodebordo, onSaveSuccess, onSaveError);
            } else {
                Diariodebordo.save(vm.diariodebordo, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('netWordAgroApp:diariodebordoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        vm.setArquivodiario = function ($file, diariodebordo) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        diariodebordo.arquivodiario = base64Data;
                        diariodebordo.arquivodiarioContentType = $file.type;
                    });
                });
            }
        };

        vm.setArquivoobservacoes = function ($file, diariodebordo) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        diariodebordo.arquivoobservacoes = base64Data;
                        diariodebordo.arquivoobservacoesContentType = $file.type;
                    });
                });
            }
        };

    }
})();
